module.exports = __webpack_public_path__ + "img/masted_forklift_trucks.91738bd7.jpg";